import React from 'react';
import SocialIcons from './subcomponents/SocialIcons';
import './Footer.css';

function Footer({ darkMode }) {
  return (
    <footer className={`footer ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="footer-left">
        <p>&copy; 2025 Lukas Schulte. All rights reserved.</p>
      </div>
      <div className="footer-right">
        <SocialIcons darkMode={darkMode} />
      </div>
    </footer>
  );
}

export default Footer;